import axios from 'axios'
import { convert } from 'html-to-text'
import writeXlsxFile from 'write-excel-file'
import { getMaxValueByKey, formatDate, sortArrayOfObjectsByKey } from './utilities'
import dayjs from 'dayjs'

const days = ['Monday', 'Tuesday', 'Wednesday', 'Thrusday', 'Friday', 'Saturday', 'Sunday']
const hours = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"]
const eventCells = ["00:00:00", "00:30:00", "01:00:00", "01:30:00", "02:00:00", "02:30:00", "03:00:00", "03:30:00", "04:00:00", "04:30:00", "05:00:00", "05:30:00", "06:00:00", "06:30:00", "07:00:00", "07:30:00", "08:00:00", "08:30:00", "09:00:00", "09:30:00", "10:00:00", "10:30:00", "11:00:00", "11:30:00", "12:00:00", "12:30:00", "13:00:00", "13:30:00", "14:00:00", "14:30:00", "15:00:00", "15:30:00", "16:00:00", "16:30:00", "17:00:00", "17:30:00", "18:00:00", "18:30:00", "19:00:00", "19:30:00", "20:00:00", "20:30:00", "21:00:00", "21:30:00", "22:00:00", "22:30:00", "23:00:00", "23:30:00"]
const supportedFormats = ["image/png", "image/jpg", "image/jpeg"]
export const FLAT_COLORS = ["#2e3131", "#392e4a", "#16453e", "#cf2f74", "#ff4c30"]
export const CHIP_COLORS = ["#16453e", "#714d69", "#6d214f", "#f9b42d", "#00b5cc"]

const Axios = axios.create( {
    baseURL: 'https://exam-api.alive.university/api/'
} )

export const BASE_URL = 'https://exam-api.alive.university'
export const ATTACHMENTS_BASE_URL = 'https://alive-content.blr1.digitaloceanspaces.com/'

export const validateQuestionsImportFormat = ( data, type ) => {
    let preview = []
    let questions = []
    let errors = []
    let errorLines = []
    let lines
    if ( type === "txt" ) {
        lines = data.split( "\n" )
        let question = null
        let options = []
        let numberOfOption = 0
        let correctAnswer = null
        let answers = []
        for ( let i = 0; i < lines.length; i++ ) {
            preview.push( `<p> ${lines[i]}</p>` )
            if ( lines[i] === "\r" ) {
                if ( ( question && question.trim() !== "" ) && ( options.length > 0 || correctAnswer ) ) {
                    errors.push( { line: i + 1, messages: ["- Answer or options not provided"] } )
                    errorLines.push( i + 1 )
                }
                question = null
                options = []
                correctAnswer = null
                numberOfOption = 0
                answers = []
            } else if ( lines[i].match( /^([A-Z][.)]\s)/ ) ) {
                const splitted = lines[i].split( /^([A-Z][.)]\s)/ )
                options.push( { text: splitted[2], status: false } )
                answers.push( splitted[1][0] )
                numberOfOption = numberOfOption + 1
            } else if ( lines[i].match( /ANSWER: / ) ) {
                const answer = lines[i].split( ": " )[1][0]
                correctAnswer = answers.indexOf( answer )
                if ( question && correctAnswer !== null && correctAnswer >= 0 && options.length > 1 ) {
                    options[correctAnswer].status = true
                    const values = { question: question, questionUrl: "", hint: "", marks: 1, questionType: "MCQ", selectionType: "single", answers: JSON.stringify( options ), correctAnswer: correctAnswer }
                    questions.push( values )
                } else {
                    let messages = []
                    if ( !question || question.trim() === "" )
                        messages.push( "- Question is not provided." )
                    if ( correctAnswer === null || correctAnswer < 0 )
                        messages.push( "- Correct answer is not provided." )
                    if ( options.length === 0 )
                        messages.push( "- Options not provided." )
                    errors.push( { line: i + 1, messages } )
                    errorLines.push( i + 1 )
                }
                question = null
                options = []
                correctAnswer = null
                numberOfOption = 0
                answers = []
            } else {
                question = lines[i]
                if ( Object.keys( options ).length > 0 || correctAnswer ) {
                    errors.push( { line: i + 1, messages: ["- Answer or options not provided"] } )
                    errorLines.push( i + 1 )
                }
                options = []
                correctAnswer = null
                numberOfOption = 0
                answers = []
            }
        }
    } else {
        lines = data.split( "</p>" )
        let question = null
        let options = []
        let numberOfOption = 0
        let correctAnswer = null
        let answers = []
        for ( let i = 0; i < lines.length; i++ ) {
            preview.push( `<p>${lines[i].substring( 3 )}</p>` )
            if ( lines[i] === "<br />" ) {
                if ( ( question && question.trim() !== "" ) && ( options.length > 0 || correctAnswer ) ) {
                    errors.push( { line: i + 1, messages: ["- Answer or options not provided"] } )
                    errorLines.push( i + 1 )
                }
                question = null
                options = []
                correctAnswer = null
                numberOfOption = 0
                answers = []
            } else if ( lines[i].match( /^(<p>[A-Z][.)]\s)/ ) ) {
                const splitted = lines[i].split( /([A-Z][.)]\s)/ )
                options.push( { text: splitted[2], status: false } )
                answers.push( splitted[1][0] )
                numberOfOption = numberOfOption + 1
            } else if ( lines[i].match( /<p>ANSWER: / ) ) {
                const answer = lines[i].split( ": " )[1][0]
                correctAnswer = answers.indexOf( answer )
                if ( question && correctAnswer !== null && correctAnswer >= 0 && options.length > 1 ) {
                    options[correctAnswer].status = true
                    const values = { question: question, questionUrl: "", hint: "", marks: 1, questionType: "MCQ", selectionType: "single", answers: JSON.stringify( options ), correctAnswer: correctAnswer }
                    questions.push( values )
                } else {
                    let messages = []
                    if ( !question || question.trim() === "" )
                        messages.push( "- Question is not provided." )
                    if ( correctAnswer === null || correctAnswer < 0 )
                        messages.push( "- Correct answer is not provided." )
                    if ( options.length === 0 )
                        messages.push( "- Options not provided." )
                    errors.push( { line: i + 1, messages } )
                    errorLines.push( i + 1 )
                }
                question = null
                options = []
                correctAnswer = null
                numberOfOption = 0
                answers = []
            } else {
                question = lines[i] + "</p>"
                if ( options.length > 0 || correctAnswer ) {
                    errors.push( { line: i + 1, messages: ["- Answer or options not provided"] } )
                    errorLines.push( i + 1 )
                }
                options = []
                correctAnswer = null
                numberOfOption = 0
                answers = []
            }
        }
    }
    return { questions, errors, preview, errorLines }
}

export const validateQuestionsImportFormatForQuestionBank = ( data, type, question_bank_id, topic_id ) => {
    let preview = []
    let questions = []
    let errors = {}
    let errorLines = []
    let lines
    if ( type === "txt" ) {
        lines = data.split( "\n" )
        let question = null
        let options = []
        let correctAnswer = null
        let answersStatus = []
        let answers = []
        for ( let i = 0; i < lines.length; i++ ) {
            preview.push( `<p> ${lines[i]}</p>` )
            if ( lines[i] === "\r" ) {
                if ( ( question && question.trim() !== "" ) && ( options.length > 0 || correctAnswer ) ) {
                    errors[i + 1] = { line: i + 1, messages: ["- Answer or options not provided"] }
                    errorLines.push( i + 1 )
                }
                question = null
                options = []
                answersStatus = []
                correctAnswer = null
                answers = []
            } else if ( lines[i].match( /^([A-Z][.)]\s)/ ) ) {
                const splitted = lines[i].split( /^([A-Z][.)]\s)/ )
                options.push( { option_text: splitted[2] } )
                answers.push( splitted[1][0] )
                answersStatus.push( false )
            } else if ( lines[i].match( /ANSWER: / ) ) {
                const answer = lines[i].split( ": " )[1][0]
                correctAnswer = answers.indexOf( answer )
                answersStatus[correctAnswer] = true
                if ( question && correctAnswer !== null && correctAnswer >= 0 && options.length > 1 ) {
                    const values = { question: question, marks: 1, questionType: "MCQ", selectionType: "single", options, correctAnswer, answersStatus, topic_id, question_bank_id }
                    questions.push( values )
                } else {
                    let messages = []
                    if ( !question || question.trim() === "" )
                        messages.push( "- Question is not provided." )
                    if ( correctAnswer === null || correctAnswer < 0 )
                        messages.push( "- Correct answer is not provided." )
                    if ( options.length === 0 )
                        messages.push( "- Options not provided." )
                    errors[i + 1] = { line: i + 1, messages }
                    errorLines.push( i + 1 )
                }
                question = null
                options = []
                correctAnswer = null
                answersStatus = []
                answers = []
            } else {
                question = lines[i]
                if ( options.length > 0 || correctAnswer ) {
                    errors[i + 1] = { line: i + 1, messages: ["- Answer or options not provided"] }
                    errorLines.push( i + 1 )
                }
                options = []
                correctAnswer = null
                answers = []
                answersStatus = []
            }
        }
    } else {
        lines = data.split( "</p>" )
        let question = null
        let options = []
        let correctAnswer = null
        let answersStatus = []
        let answers = []
        for ( let i = 0; i < lines.length; i++ ) {
            preview.push( `<p>${lines[i].substring( 3 )}</p>` )
            if ( lines[i] === "<br />" ) {
                if ( ( question && question.trim() !== "" ) && ( options.length > 0 || correctAnswer ) ) {
                    errors[i + 1] = { line: i + 1, messages: ["- Answer or options not provided"] }
                    errorLines.push( i + 1 )
                }
                question = null
                options = []
                correctAnswer = null
                answers = []
            } else if ( lines[i].match( /^(<p>[A-Z][.)]\s)/ ) ) {
                const splitted = lines[i].split( /([A-Z][.)]\s)/ )
                options.push( { option_text: splitted[2] } )
                answers.push( splitted[1][0] )
                answersStatus.push( false )
            } else if ( lines[i].match( /<p>ANSWER: / ) ) {
                const answer = lines[i].split( ": " )[1][0]
                correctAnswer = answers.indexOf( answer )
                answersStatus[correctAnswer] = true
                if ( question && correctAnswer !== null && correctAnswer >= 0 && options.length > 1 ) {
                    const values = { question: question, marks: 1, questionType: "MCQ", selectionType: "single", options, correctAnswer, answersStatus, topic_id, question_bank_id }
                    questions.push( values )
                } else {
                    let messages = []
                    if ( !question || question.trim() === "" )
                        messages.push( "- Question is not provided." )
                    if ( correctAnswer === null || correctAnswer < 0 )
                        messages.push( "- Correct answer is not provided." )
                    if ( options.length === 0 )
                        messages.push( "- Options not provided." )
                    errors[i + 1] = { line: i + 1, messages }
                    errorLines.push( i + 1 )
                }
                question = null
                options = {}
                correctAnswer = null
                answersStatus = []
                answers = []
            } else {
                question = lines[i] + "</p>"
                if ( options.length > 0 || correctAnswer ) {
                    errors[i + 1] = { line: i + 1, messages: ["- Answer or options not provided"] }
                    errorLines.push( i + 1 )
                }
                options = []
                correctAnswer = null
                answersStatus = []
                answers = []
            }
        }
    }
    return { questions, errors, preview, errorLines }
}

const getCurrentWeek = ( date = new Date() ) => {
    const curr = new Date( date )
    const dday = curr.getDay()
    let week = []
    if ( dday === 0 ) {
        for ( let i = 5; i >= -1; i-- ) {
            let tempCurr = new Date( date )
            let first = tempCurr.getDate() - i
            let day = new Date( tempCurr.setDate( first ) ).toISOString().slice( 0, 10 )
            week.push( day )
        }
    }
    else if ( dday !== 0 ) {
        for ( let i = 1; i <= 6; i++ ) {
            let first = curr.getDate() - curr.getDay() + i + 1
            let day = new Date( curr.setDate( first ) ).toISOString().slice( 0, 10 )
            week.push( day )
        }
        week.push( new Date( curr.setDate( curr.getDate() + 1 ) ).toISOString().slice( 0, 10 ) )
    }

    return week
}

const getPreviousWeek = ( currentWeekStartDate ) => {
    const currentWeekDate = new Date( currentWeekStartDate[0] )
    console.log( currentWeekStartDate )
    const newWeekDate = new Date( currentWeekDate.setDate( currentWeekDate.getDate() - 7 ) )
    const formatedDate = newWeekDate.toLocaleDateString( 'en-us', { year: "numeric", month: "numeric", day: "numeric" } ).replace( /\//g, '-' )
    console.log( getCurrentWeek( formatedDate ) )
    return getCurrentWeek( formatedDate )
}

const getPreviousWorkWeek = ( currentWeekStartDate ) => {
    const currentWeekDate = new Date( currentWeekStartDate[0] )
    const newWeekDate = new Date( currentWeekDate.setDate( currentWeekDate.getDate() - 7 ) )
    const formatedDate = newWeekDate.toLocaleDateString( 'en-us', { year: "numeric", month: "numeric", day: "numeric" } ).replace( /\//g, '-' )
    return getCurrentWorkWeek( formatedDate )
}

const getNextWeek = ( currentWeekStartDate ) => {
    const currentWeekDate = new Date( currentWeekStartDate[0] )
    const newWeekDate = new Date( currentWeekDate.setDate( currentWeekDate.getDate() + 7 ) )
    const formatedDate = newWeekDate.toLocaleDateString( 'en-us', { year: "numeric", month: "numeric", day: "numeric" } ).replace( /\//g, '-' )
    return getCurrentWeek( formatedDate )
}

const getNextWorkWeek = ( currentWeekStartDate ) => {
    const currentWeekDate = new Date( currentWeekStartDate[0] )
    const newWeekDate = new Date( currentWeekDate.setDate( currentWeekDate.getDate() + 7 ) )
    const formatedDate = newWeekDate.toLocaleDateString( 'en-us', { year: "numeric", month: "numeric", day: "numeric" } ).replace( /\//g, '-' )
    return getCurrentWorkWeek( formatedDate )
}

const getCurrentWorkWeek = ( date = new Date() ) => {
    const curr = new Date( date )
    const dday = curr.getDay()
    let week = []
    if ( dday === 0 ) {
        for ( let i = 5; i >= -1; i-- ) {
            let tempCurr = new Date( date )
            let first = tempCurr.getDate() - i
            let day = new Date( tempCurr.setDate( first ) ).toISOString().slice( 0, 10 )
            week.push( day )
        }
    }
    else if ( dday !== 0 ) {
        for ( let i = 1; i <= 6; i++ ) {
            let first = curr.getDate() - curr.getDay() + i + 1
            let day = new Date( curr.setDate( first ) ).toISOString().slice( 0, 10 )
            week.push( day )
        }
    }
    return week.slice( 0, 5 )
}

const getCurrentDate = ( date = new Date() ) => {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thrusday', 'Friday', 'Saturday']
    const today = new Date( date )
    const formatedDate = today.toLocaleDateString( 'en-us', { year: "numeric", month: "numeric", day: "numeric" } )
    return [formatedDate.replace( /\//g, '-' ), today.getDate(), days[today.getDay()]]
}

const getPreviousDate = ( currentDate ) => {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thrusday', 'Friday', 'Saturday']
    const current = new Date( currentDate )
    const previousDate = new Date( current.setDate( current.getDate() - 1 ) )
    const formatedDate = previousDate.toLocaleDateString( 'en-us', { year: "numeric", month: "numeric", day: "numeric" } ).replace( /\//g, '-' )
    return [formatedDate, previousDate.getDate(), days[previousDate.getDay()]]
}

const getNextDate = ( currentDate ) => {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thrusday', 'Friday', 'Saturday']
    const current = new Date( currentDate )
    const nextDate = new Date( current.setDate( current.getDate() + 1 ) )
    const formatedDate = nextDate.toLocaleDateString( 'en-us', { year: "numeric", month: "numeric", day: "numeric" } ).replace( /\//g, '-' )
    return [formatedDate, nextDate.getDate(), days[nextDate.getDay()]]
}

const jsDateFormat = ( date ) => {
    let d = date.split( "T" )[0]
    d = new Date( d ).setDate( new Date( d ).getDate() + 1 )
    return ( new Date( d ).toISOString() ).split( "T" )[0]
}

const formatDateTimeForInputField = ( date, time ) => {
    const dateInSec = new Date( date ).getTime()
    let newDate = new Date( dateInSec + ( 5.5 * 60 * 60 ) ).toLocaleDateString( 'en-US', { month: "2-digit", day: "2-digit", year: "numeric" } ).split( "/" )
    return `${newDate[2]}-${newDate[0]}-${newDate[1]}T${time.substring( 0, 5 )}`
}

const formatDateTimeForDB = ( date, code = "en-IN", delimiter = "-" ) => {
    let d = new Date( date ).toLocaleDateString( code, { month: "2-digit", year: "numeric", day: "2-digit", hour: "2-digit", minute: "2-digit" } )
    d = d.replace( /\//g, delimiter )
    const data = {}
    data.dateTime = d
    data.date = d.split( "," )[0]
    data.date = data.date.split( delimiter ).reverse().join( delimiter )
    data.time = d.split( ", " )[1].substring( 0, 5 )
    data.period = d.split( " " )[2]
    if ( data.period === 'pm' && data.time.split( ":" )[0] !== "12" ) {
        let time = parseInt( data.time.split( ":" )[0] ) + 12
        data.twentyFourFormat = `${time}:${data.time.split( ":" )[1]}`
    } else if ( data.period === 'am' && data.time.split( ":" )[0] === "12" ) {
        data.twentyFourFormat = `00:${data.time.split( ":" )[1]}`
    }
    else {
        data.twentyFourFormat = data.time
    }
    return data
}

const formatDateTimeForDisplay = ( date, time ) => {
    const dateTime = dayjs( formatDateTimeForInputField( date, time ) )
    return dateTime.format( "DD MMM YYYY, hh:mm A" )
}

const normalDateFormat = ( date ) => {
    let d = date.split( "T" )[0]
    d = new Date( d ).setDate( new Date( d ).getDate() + 1 )
    return ( new Date( d ).toLocaleDateString( "en-GB", { year: "numeric", day: "2-digit", month: "2-digit" } ) ).replace( /\//g, '-' )
}

const downloadParticipationReport = async ( participation, questions, submissions ) => {
    let rows = [[{ fontWeight: 'bold', value: "Q.No" }, { value: "Question", fontWeight: 'bold' }, { fontWeight: 'bold', value: "Question Point" }, { value: "Answer", fontWeight: 'bold' }, { value: "Score", fontWeight: 'bold' }]]
    for ( let i = 0; i < questions.length; i++ ) {
        let row = [{ value: i + 1, type: Number }]
        const question = questions[i].question
        const options = questions[i].options
        const answerMap = {}
        if ( options ) {
            options.forEach( option => {
                answerMap[option.answer_id] = `"${convert( option.answer_text ).replace( /"/g, '""' )}"`
            } )
        }
        row.push( { value: `"${convert( question.question_text ).replace( /"/g, '""' )}"`, type: String } )
        row.push( { value: question.question_point, type: Number } )
        if ( submissions[question.question_id] ) {
            const submission = submissions[question.question_id]
            if ( submission.length === 1 ) {
                if ( submission[0].answer_id ) {
                    row.push( { value: String( answerMap[submission[0].answer_id] ), type: String } )
                } else {
                    row.push( { value: `"${convert( submission[0].answer_descriptive ).replace( /"/g, '""' )}"`, type: String } )
                }
            } else if ( submission.length > 1 ) {
                let answers = []
                submission.forEach( ans => {
                    answers.push( answerMap[ans.answer_id] )
                } )
                row.push( { value: `"{${answers.join( "," )}}"`, type: String } )
            }
            if ( submission[0].submission_score || submission[0].submission_score === 0 ) row.push( { value: submission[0].submission_score, type: Number } )
            else row.push( { value: "Not yet evaluated", type: String } )

        } else {
            row.push( { value: "Answer not given", type: String } )
            row.push( { value: 0, type: Number } )
        }
        rows.push( row )
    }
    // let csvContent = ''
    // rows.forEach( row => {
    //     csvContent += `${row.join( "," )}\n`
    // } )
    const excelData = await writeXlsxFile( rows, { buffer: true } )
    const blob = new Blob( [excelData] )
    const a = document.createElement( 'a' )
    a.download = `${participation.exam_title}${participation.student_name ? "-" + participation.student_name : ""}-Attempt-${participation.exam_participation_attempt}-test-report.xlsx`
    a.href = window.URL.createObjectURL( blob )
    a.click()
}


const exportQuizReport = async ( data, title, date, noAttemptStudentListIncluded ) => {
    let rows = [[
        { fontWeight: 'bold', value: "Q.No", align: 'center' },
        { value: "Student name", fontWeight: 'bold', width: 70 },
        { fontWeight: 'bold', value: "AUID", width: 20 },
        { fontWeight: 'bold', value: "USN", width: 20 },
        { value: "MAX marks", fontWeight: 'bold', align: 'center', width: 12 },
        { value: "Score", fontWeight: 'bold', align: 'center', width: 10 }
    ]]
    for ( let i = 0; i < data.length; i++ ) {
        const participation = data[i]
        let row = []
        row.push( { value: i + 1, width: "200px", type: Number, backgroundColor: participation.no_attempt ? '#fce4d6' : undefined, align: "center" } )
        row.push( { value: participation?.student_details?.name || "", width: "200px", type: String, backgroundColor: participation.no_attempt ? '#fce4d6' : undefined } )
        row.push( { value: participation.student_id, width: "200px", type: String, backgroundColor: participation.no_attempt ? '#fce4d6' : undefined } )
        row.push( { value: participation?.student_details?.usn || "", width: "200px", type: String, backgroundColor: participation.no_attempt ? '#fce4d6' : undefined } )
        row.push( { value: +participation.max_score, width: "200px", type: Number, backgroundColor: participation.no_attempt ? '#fce4d6' : undefined, align: "center" } )
        row.push( { value: +participation.total_score, width: "200px", type: Number, backgroundColor: participation.no_attempt ? '#fce4d6' : undefined, align: "center" } )
        rows.push( row )
    }

    if ( !noAttemptStudentListIncluded ) {
        const customMessage = "The batch or section assigned to this resource belongs to a previous academic year and is no longer active, so the list of students who did not attempt this exam cannot be displayed."

        data.push( [
            {
                value: customMessage,
                span: rows.at( 0 ).length,
                fontWeight: "bold",
                backgroundColor: "#FFFF00"
            },
            ...new Array( rows.at( 0 ).length - 1 ).fill( null ),
        ] )
    }

    const excelData = await writeXlsxFile( rows, { columns: rows[0], buffer: true } )
    const blob = new Blob( [excelData] )
    const a = document.createElement( 'a' )
    a.download = `${title}-${formatDate( date )}-report.xlsx`
    a.href = window.URL.createObjectURL( blob )
    a.click()
}

const exportQuizMonthlyReportStudents = async ( students, reportLabel ) => {
    const head = [
        { width: 10, fontWeight: 'bold', value: "Sl.No.", align: "center" },
        { width: 20, fontWeight: 'bold', value: "USN" },
        { width: 15, fontWeight: 'bold', value: "Branch" },
        { width: 10, fontWeight: 'bold', value: "Section", align: "center" },
        { width: 15, fontWeight: 'bold', value: "Academic Year", align: "center" },
        { width: 15, fontWeight: 'bold', value: "Attempts", align: "center" },
        { width: 18, fontWeight: 'bold', value: "Quizzes Attempted", align: "center" },
        { width: 15, fontWeight: 'bold', value: "Average %", align: "center" },
        { width: 15, fontWeight: 'bold', value: "Average Score", align: "center" },
        { width: 15, fontWeight: 'bold', value: "Highest %", align: "center" },
        { width: 15, fontWeight: 'bold', value: "Lowest %", align: "center" },
        { width: 22, fontWeight: 'bold', value: "Last Attempted" },
    ]

    let data = [head]
    students.forEach( ( student, index ) => {
        data.push( [
            { value: index + 1, type: Number, align: "center" },
            { value: student.usn || "", type: String },
            { value: student.branch_name || "", type: String },
            { value: student.section || "", type: String, align: "center" },
            { value: student.ac_year || "", type: String, align: "center" },
            { value: +student.attempts || 0, type: Number, align: "center" },
            { value: +student.quizzes_attempted || 0, type: Number, align: "center" },
            { value: +student.average_percentage || 0, type: Number, align: "center" },
            { value: +student.average_score || 0, type: Number, align: "center" },
            { value: +student.highest_percentage || 0, type: Number, align: "center" },
            { value: +student.lowest_percentage || 0, type: Number, align: "center" },
            { value: student.last_attempted_at ? formatDate( student.last_attempted_at, { showTime: true } ) : "-", type: String },
        ] )
    } )

    const excelData = await writeXlsxFile( data, { columns: head, buffer: true } )
    const blob = new Blob( [excelData] )
    const a = document.createElement( 'a' )
    a.download = `quiz-monthly-report${reportLabel ? `-${reportLabel.replace( /\s+/g, '-' ).toLowerCase()}` : ""}.xlsx`
    a.href = window.URL.createObjectURL( blob )
    a.click()
}

const exportExamParticipation = async ( participations, totalMarks, noAttemptStudentListIncluded = false ) => {
    const maxAvailableAttempt = +( getMaxValueByKey( participations, 'exam_participation_attempt' ) || 1 )
    const attemptColumns = []
    for ( let i = 0; i < maxAvailableAttempt; i++ ) {
        attemptColumns.push( { align: "center", fontWeight: "bold", value: `Attempt ${i + 1}(Score)`, width: 20 } )
    }
    attemptColumns.push( { align: "center", backgroundColor: "#FF0", fontWeight: "bold", value: `Best Attempt(Score)`, width: 20 } )

    const students = {}


    for ( const item of participations ) {
        if ( students[item.student_id] !== undefined ) {
            students[item.student_id].scores[+item.exam_participation_attempt - 1] = item.exam_participation_score
            if ( students[item.student_id].attempt_status !== 'Completed' && item.exam_participation_status !== 'Not started' )
                students[item.student_id].attempt_status = item.exam_participation_status
            if ( students[item.student_id].best_score < +item.exam_participation_score ) {
                students[item.student_id].best_score = +item.exam_participation_score
                students[item.student_id].end_timestamp = formatDate( item.exam_participation_end_time, { showTime: true } )?.toUpperCase()
            }
        } else {
            const studentRowDetails = {}
            studentRowDetails.no_participation = item.no_participation
            studentRowDetails.student_name = item.student_name
            studentRowDetails.student_id = item.student_id
            studentRowDetails.student_usn = item.student_usn || ""
            studentRowDetails.best_score = item.exam_participation_score
            studentRowDetails.scores = []
            studentRowDetails.attempt_status = []
            studentRowDetails.scores[+item.exam_participation_attempt - 1] = item.exam_participation_score
            studentRowDetails.end_timestamp = formatDate( item.exam_participation_end_time, { showTime: true } )?.toUpperCase()

            studentRowDetails.attempt_status = ['In progress', 'Completed', 'No Attempt'].includes( item.exam_participation_status ) ? item.exam_participation_status : undefined
            students[item.student_id] = studentRowDetails
        }
    }
    const head = [{ width: 10, fontWeight: 'bold', value: "Sl.No.", align: "center" }, { width: 70, fontWeight: 'bold', value: "Student Name" }, { width: 20, fontWeight: 'bold', value: "AUID" }, { width: 20, fontWeight: 'bold', value: "USN" }, { width: 20, fontWeight: 'bold', value: "Participation Status" }, { align: "center", width: 20, fontWeight: 'bold', value: "Total marks" }, ...attemptColumns, { width: 20, fontWeight: 'bold', value: "Exam Finish Date and Time(Best attempt)" }]
    head.forEach( h => h.borderColor = "#000000" )

    let data = []
    data.push( head )
    Object.keys( students ).forEach( ( student_id, index ) => {
        const studentDetails = students[student_id]
        let row = []
        row.push( { value: index + 1, width: 10, type: Number, align: "center", backgroundColor: studentDetails.no_participation ? '#fce4d6' : undefined, borderColor: "#000000" } )
        row.push( { value: ( studentDetails.student_name ).replace( /"/g, '""' ), width: 20, type: String, backgroundColor: studentDetails.no_participation ? '#fce4d6' : undefined, borderColor: "#000000" } )
        row.push( { value: ( studentDetails.student_id ).replace( /"/g, '""' ), width: 20, type: String, backgroundColor: studentDetails.no_participation ? '#fce4d6' : undefined, borderColor: "#000000" } )
        row.push( { value: ( studentDetails.student_usn ).replace( /"/g, '""' ), width: 20, type: String, backgroundColor: studentDetails.no_participation ? '#fce4d6' : undefined, borderColor: "#000000" } )
        row.push( { value: studentDetails.attempt_status || "Not started", width: 20, type: String, backgroundColor: studentDetails.no_participation ? '#fce4d6' : undefined, borderColor: "#000000" } )
        row.push( { value: totalMarks || "Not started", width: 20, type: Number, align: "center", backgroundColor: studentDetails.no_participation ? '#fce4d6' : undefined, borderColor: "#000000" } )
        for ( let j = 0; j < maxAvailableAttempt; j++ ) {
            row.push( { value: studentDetails.scores[j] ?? "-", width: 20, align: "center", backgroundColor: studentDetails.no_participation ? '#fce4d6' : undefined, borderColor: "#000000" } )
        }
        row.push( { value: studentDetails.best_score ?? 0, width: 20, type: Number, align: "center", backgroundColor: studentDetails.no_participation ? '#fce4d6' : undefined, borderColor: "#000000" } )
        row.push( { value: studentDetails.end_timestamp, width: 20, type: String, backgroundColor: studentDetails.no_participation ? '#fce4d6' : undefined, borderColor: "#000000" } )
        data.push( row )
    } )

    if ( !noAttemptStudentListIncluded ) {
        const customMessage = "The batch or section assigned to this resource belongs to a previous academic year and is no longer active, so the list of students who did not attempt this exam cannot be displayed."

        data.push( [
            {
                value: customMessage,
                span: head.length,
                fontWeight: "bold",
                backgroundColor: "#FFFF00"
            },
            ...new Array( head.length - 1 ).fill( null ),
        ] )
    }

    const excelFile = await writeXlsxFile( data, { columns: head, buffer: true } )
    const blob = new Blob( [excelFile] )
    const a = document.createElement( 'a' )
    a.download = `${participations[0].exam_title}-participation-report.xlsx`
    a.href = window.URL.createObjectURL( blob )
    a.click()
}

const exportAdmissionExamParticipation = async ( participations, exam_title ) => {
    const maxAvailableAttempt = +( getMaxValueByKey( participations, 'exam_participation_attempt' ) || 1 )
    const attemptColumns = []

    for ( let i = 0; i < maxAvailableAttempt; i++ ) {
        attemptColumns.push( { align: "center", fontWeight: "bold", value: `Attempt ${i + 1}(Score)` } )
    }
    attemptColumns.push( { align: "center", backgroundColor: "#0F0", color: "#fff", fontWeight: "bold", value: `Best Attempt(Score)` } )
    const sortedList = sortArrayOfObjectsByKey( participations, 'student_name', -1 )

    const students = {}

    for ( const item of sortedList ) {
        if ( students[item.student_id] !== undefined ) {
            students[item.student_id].scores[+item.exam_participation_attempt - 1] = item.exam_participation_score
            if ( students[item.student_id].attempt_status !== 'Completed' && item.exam_participation_status !== 'Not started' )
                students[item.student_id].attempt_status = item.exam_participation_status
            if ( students[item.student_id].best_score < +item.exam_participation_score ) {
                students[item.student_id].best_score = +item.exam_participation_score
                students[item.student_id].end_timestamp = formatDate( item.exam_participation_end_time, { showTime: true } )
            }
        } else {
            const studentRowDetails = {}
            studentRowDetails.total_marks = item.total_marks
            studentRowDetails.student_name = item.student_name
            studentRowDetails.student_id = item.student_id
            studentRowDetails.best_score = item.exam_participation_score
            studentRowDetails.scores = []
            studentRowDetails.attempt_status = []
            studentRowDetails.scores[+item.exam_participation_attempt - 1] = item.exam_participation_score
            studentRowDetails.end_timestamp = formatDate( item.exam_participation_end_time, { showTime: true } )

            studentRowDetails.attempt_status = ['In progress', 'Completed'].includes( item.exam_participation_status ) ? item.exam_participation_status : undefined
            students[item.student_id] = studentRowDetails
        }
    }
    const head = [{ width: 20, fontWeight: 'bold', value: "Sl.No." }, { width: 20, fontWeight: 'bold', value: "AUID" }, { width: 20, fontWeight: 'bold', value: "Student Name" }, { width: 20, fontWeight: 'bold', value: "Participation Status" }, { align: "center", width: 20, fontWeight: 'bold', value: "Total marks" }, ...attemptColumns, { width: 20, fontWeight: 'bold', value: "Exam Finish Date and Time(Best attempt)" }]

    let data = []
    data.push( head )
    Object.keys( students ).sort().forEach( ( student_id, index ) => {
        const studentDetails = students[student_id]
        let row = []
        row.push( { value: index + 1, width: 20, type: Number } )
        row.push( { value: ( studentDetails.student_id ).replace( /"/g, '""' ), width: 20, type: String } )
        row.push( { value: ( studentDetails.student_name ).replace( /"/g, '""' ), width: 20, type: String } )
        row.push( { value: studentDetails.attempt_status || "Not started", width: 20, type: String } )
        row.push( { value: studentDetails.total_marks || "Not started", width: 20, type: Number, align: "center" } )
        for ( let j = 0; j < maxAvailableAttempt; j++ ) {
            row.push( { value: studentDetails.scores[j] || "-", width: 20, align: "center" } )
        }
        row.push( { value: studentDetails.best_score, width: 20, type: Number, align: "center" } )
        row.push( { value: studentDetails.end_timestamp, width: 20, type: String } )
        data.push( row )
    } )
    const excelFile = await writeXlsxFile( data, { buffer: true } )
    const blob = new Blob( [excelFile] )
    const a = document.createElement( 'a' )
    a.download = `${exam_title}-participation-report.xlsx`
    a.href = window.URL.createObjectURL( blob )
    a.click()
}

export const exportAdmissionExamParticipationSectionwise = async ( participations, exam_title ) => {
    const maxAvailableAttempt = +( getMaxValueByKey( participations, 'exam_participation_attempt' ) || 1 )
    const attemptColumns = []
    const sections = participations[0].sections

    for ( let i = 0; i < maxAvailableAttempt; i++ ) {
        attemptColumns.push( { align: "center", fontWeight: "bold", value: `Attempt ${i + 1}(Score)` } )
    }
    attemptColumns.push( { span: sections.length + 1, align: "center", fontWeight: "bold", value: `Best Attempt(Score)` } )
    for ( let i = 0; i < sections.length; i++ ) {
        attemptColumns.push( null )
    }
    const head = [
        { width: 20, fontWeight: 'bold', value: "Sl.No." },
        { width: 20, fontWeight: 'bold', value: "AUID" },
        { width: 20, fontWeight: 'bold', value: "Student Name" },
        { width: 20, fontWeight: 'bold', value: "Participation Status" },
        { align: "center", width: 20, fontWeight: 'bold', value: "Total marks" },
        ...attemptColumns,
        { width: 20, fontWeight: 'bold', value: "Exam Finish Date and Time(Best attempt)" }
    ]


    const emptyRow = []
    for ( let i = 0; i < head.length; i++ ) {
        if ( i < 5 + maxAvailableAttempt ) {
            emptyRow.push( null )
        } else if ( i === 5 + maxAvailableAttempt ) {
            for ( let j = 0; j < sections.length; j++ ) {
                emptyRow.push( { width: 20, align: "center", fontWeight: 'bold', value: sections[j] } )
            }
            emptyRow.push( { width: 20, fontWeight: 'bold', value: "Total" } )
            i += sections.length
        } else {
            emptyRow.push( null )
        }
    }

    const sortedList = sortArrayOfObjectsByKey( participations, 'student_name', -1 )

    const students = {}

    for ( const item of sortedList ) {
        if ( students[item.student_id] !== undefined ) {
            students[item.student_id].scores[+item.exam_participation_attempt - 1] = item.exam_participation_score
            if ( students[item.student_id].attempt_status !== 'Completed' && item.exam_participation_status !== 'Not started' )
                students[item.student_id].attempt_status = item.exam_participation_status
            if ( students[item.student_id].best_score < +item.exam_participation_score ) {
                students[item.student_id].section_scores = item.sectionScores
                students[item.student_id].best_score = +item.exam_participation_score
                students[item.student_id].percentage = +item.percentage
                students[item.student_id].end_timestamp = formatDate( item.exam_participation_end_time, { showTime: true } )
            }
        } else {
            const studentRowDetails = {}
            studentRowDetails.student_id = item.student_id
            studentRowDetails.total_marks = item.total_marks
            studentRowDetails.student_name = item.student_name
            studentRowDetails.section_scores = item.sectionScores
            studentRowDetails.best_score = item.exam_participation_score
            studentRowDetails.percentage = item.percentage
            studentRowDetails.scores = []
            studentRowDetails.attempt_status = []
            studentRowDetails.scores[+item.exam_participation_attempt - 1] = item.exam_participation_score
            studentRowDetails.end_timestamp = formatDate( item.exam_participation_end_time, { showTime: true } )

            studentRowDetails.attempt_status = ['In progress', 'Completed'].includes( item.exam_participation_status ) ? item.exam_participation_status : undefined
            students[item.student_id] = studentRowDetails
        }
    }

    let data = []
    data.push( head )
    data.push( emptyRow )
    Object.keys( students ).sort().forEach( ( student_id, index ) => {
        const studentDetails = students[student_id]
        let row = []
        row.push( { value: index + 1, width: 20, type: Number } )
        row.push( { value: ( studentDetails.student_id ).replace( /"/g, '""' ), width: 20, type: String } )
        row.push( { value: ( studentDetails.student_name ).replace( /"/g, '""' ), width: 20, type: String } )
        row.push( { value: studentDetails.attempt_status || "Not started", width: 20, type: String } )
        row.push( { value: studentDetails.total_marks || "Not started", width: 20, type: Number, align: "center" } )
        for ( let j = 0; j < maxAvailableAttempt; j++ ) {
            row.push( { value: studentDetails.scores[j] || "-", width: 20, align: "center" } )
        }
        for ( const section of sections ) {
            row.push( { value: `${studentDetails.section_scores[section].scoredMarks}/${studentDetails.section_scores[section].totalMarks} (${studentDetails.section_scores[section].sectionPercentage?.toFixed( 2 )}%)`, width: 20, type: String, align: "center" } )
        }

        row.push( { value: `${studentDetails.best_score}/${studentDetails.total_marks} (${studentDetails.percentage?.toFixed( 2 )}%)`, width: 20, type: String, align: "center" } )
        row.push( { value: studentDetails.end_timestamp, width: 20, type: String } )
        data.push( row )
    } )
    const excelFile = await writeXlsxFile( data, { buffer: true } )
    const blob = new Blob( [excelFile] )
    const a = document.createElement( 'a' )
    a.download = `${exam_title}-participation-report.xlsx`
    a.href = window.URL.createObjectURL( blob )
    a.click()
}

const uploadQuestionImage = async ( file ) => {
    console.log( file )
    const data = new FormData()
    data.append( "file", file )
    const res = await axios.post( `${BASE_URL}/exams/addquestionimage`, data )
    console.log( ( res.data ) )
    let url = ''
    return url
}

const instituteCourseAndBranches = {
    "AGS": [
        {
            "course": "BA",
            "branch": "PCE",
            "course_branch_name": "BA - PSYCHOLOGY/CRIMINOLOGY/ENGLISH"
        },
        {
            "course": "BA",
            "branch": "PJE",
            "course_branch_name": "BA - PSYCHOLOGY/JOURNALISM/ENGLISH"
        },
        {
            "course": "BBA",
            "branch": "BBA",
            "course_branch_name": "BACHELOR OF BUSINESS ADMINISTRATION"
        },
        {
            "course": "BBA – Digital Marketing",
            "branch": "BBA-Digital",
            "course_branch_name": "Digital Marketing"
        },
        {
            "course": "BBA-Analytics",
            "branch": "Analytics",
            "course_branch_name": "Business Analytics"
        },
        {
            "course": "BBA - AV",
            "branch": "BBA - AV",
            "course_branch_name": "BACHELOR OF BUSINESS ADMINISTRATION - AVIATION"
        },
        {
            "course_branch_name": "BACHELOR OF COMPUTER APPLICATION",
            "course": "BCA",
            "branch": "BCA"
        },
        {
            "course_branch_name": "BCA DATA SCIENCE",
            "course": "BCA -DS",
            "branch": "BCA -DS"
        }, {
            "course_branch_name": "BCA CLOUD COMPUTING",
            "branch": "BCA-CC",
            "course": "CLOUD COMPUTING"
        },
        {
            "course": "ACCA",
            "branch": "BCOM ACCA",
            "course_branch_name": "BCOM ACCA"
        }, {
            "course": "BCOM CMA",
            "branch": "BCOM-CMA",
            "course_branch_name": "BCOM CMA"
        },
        {
            "course": "BCOM",
            "branch": "BCOM",
            "course_branch_name": "BACHELOR OF COMMERCE"
        },
        {
            "course": "BSC",
            "branch": "PMC",
            "course_branch_name": "PHYSICS/MATHS/COMPUTERS"
        },
        {
            "course": "BSc - CSCDS",
            "branch": "BSc CSCDS",
            "course_branch_name": "BSc CSCDS"
        },
        {
            "course": "BSC FAD",
            "branch": "BSCFAD",
            "course_branch_name": "FASHION AND APPAREL DESIGN"
        },
        {
            "course": "BSW",
            "branch": "BSW",
            "course_branch_name": "BACHELOR OF SOCIAL WORK"
        }
    ],
    "AIT": [
        {
            "course": "BE",
            "branch": "AE",
            "course_branch_name": "AERONAUTICAL ENGG"
        },
        {
            "course": "BE",
            "branch": "BT",
            "course_branch_name": "BIOTECHNOLOGY"
        },
        {
            "course": "BE",
            "branch": "CV",
            "course_branch_name": "CIVIL ENGG"
        },
        {
            "course": "BE",
            "branch": "EC",
            "course_branch_name": "ELECTRONICS & COMMUNICATION ENGG"
        },
        {
            "course": "BE",
            "branch": "EE",
            "course_branch_name": "ELECTRICAL & ELECTRONICS ENGG"
        },
        {
            "course": "BE",
            "branch": "ME",
            "course_branch_name": "MECHANICAL ENGG"
        },
        {
            "course": "BE",
            "branch": "MT",
            "course_branch_name": "MECHATRONICS ENGG"
        },
        {
            "course": "BE",
            "branch": "CS",
            "course_branch_name": "COMPUTER SCIENCE ENGG"
        },
        {
            "course": "BE",
            "branch": "IS",
            "course_branch_name": "INFORMATION SCIENCE ENGG"
        },
        {
            "course": "BE",
            "branch": "AIML",
            "course_branch_name": "ARTIFICIAL INTELLIGENCE & MACHINE LEARNING"
        },
        {
            "course": "BE",
            "branch": "CSD",
            "course_branch_name": "Computer Science & Engineering (Data Science)"
        }
    ]
}

export const getAdmissionExamBranchesCodes = () => {
    const institutes = Object.keys( instituteCourseAndBranches )
    let codes = []
    for ( let i = 0; i < institutes.length; i++ ) {
        const institute = institutes[i]
        codes.push( ...instituteCourseAndBranches[institute]?.map( i => i.branch ) )
    }
    return codes
}


export { exportAdmissionExamParticipation, instituteCourseAndBranches, exportQuizReport, exportQuizMonthlyReportStudents, exportExamParticipation, downloadParticipationReport, formatDateTimeForDB, formatDateTimeForDisplay, formatDateTimeForInputField, Axios, getCurrentWeek, uploadQuestionImage, supportedFormats, normalDateFormat, jsDateFormat, getCurrentDate, days, eventCells, hours, getCurrentWorkWeek, getPreviousWeek, getPreviousWorkWeek, getNextWorkWeek, getNextWeek, getPreviousDate, getNextDate }

// const getCurrentWeek = ( date = new Date() ) => {
//     const curr = new Date( date )
//     const dday = curr.getDay()
//     let week = []
//     if ( dday === 0 ) {
//         for ( let i = 5; i >= -1; i-- ) {
//             let tempCurr = new Date( date )
//             let first = tempCurr.getDate() - i
//             let day = new Date( tempCurr.setDate( first ) ).toISOString().slice( 0, 10 )
//             week.push( day )
//         }
//     }
//     else if ( dday !== 0 ) {
//         for ( let i = 1; i <= 6; i++ ) {
//             let first = curr.getDate() - curr.getDay() + i + 1
//             let day = new Date( curr.setDate( first ) ).toISOString().slice( 0, 10 )
//             week.push( day )
//         }
//         week.push( new Date( curr.setDate( curr.getDate() + 1 ) ).toISOString().slice( 0, 10 ) )
//     }

//     return week
// }
// <p><img src="https://content-ai.sgp1.digitaloceanspaces.com/temp/1666510241861.DarkLogo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&amp;X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&amp;X-Amz-Credential=FDDWKZU3GR54F3DS6IXF%2F20221023%2Fsgp1%2Fs3%2Faws4_request&amp;X-Amz-Date=20221023T073043Z&amp;X-Amz-Expires=3600&amp;X-Amz-Signature=2fd5749a217271ccf5fd9a93a5da0b9a5a5b510dc4cdb2d830781f0676632e9a&amp;X-Amz-SignedHeaders=host&amp;x-id=GetObject"></p>
